import { useApiClientBase } from "../api/apiClient";

/**
 * useProfileApi is a custom hook that provides an API function
 * for fetching the user's profile information.
 * It uses the configured API client and error handler from useApiClientBase.
 *
 * @returns { getProfile } - Function to fetch user profile information.
 */
export const useProfileApi = () => {
  const { apiClient, handleError } = useApiClientBase();

  /**
   * Fetches the user profile information from the backend API.
   *
   * @returns {Promise<any>} - The response data containing the user's profile, or null if an error occurs.
   */
  const getProfile = async () => {
    try {
      const response = await apiClient.get("/Login/profile");
      return response.data;
    } catch (err) {
      return handleError(err, "fetching profile");
    }
  };

  return { getProfile };
};
